import jsonSchemaForm from "./json-schema-form";

export default angular.module("vesl.extensions.json-schema", [jsonSchemaForm]).name;
